import {
  Home, Building2, Euro, PieChart, Waves, LineChart, Sparkles,
  AlertTriangle, CheckSquare, MessageSquareText, FolderOpen, CalendarDays,
  Lightbulb, Users,
} from 'lucide-react';

export const navGroups = [
  {
    labelKey: 'nav.group.overview',
    items: [
      { key: 'today', path: '/app/today', icon: Home, labelKey: 'nav.today' },
      { key: 'company', path: '/app/company', icon: Building2, labelKey: 'nav.company' },
      { key: 'finance', path: '/app/finance', icon: Euro, labelKey: 'nav.finance' },
    ],
  },
  {
    labelKey: 'nav.group.intelligence',
    items: [
      { key: 'profitability', path: '/app/profitability', icon: PieChart, labelKey: 'nav.profitability' },
      { key: 'cash', path: '/app/cash', icon: Waves, labelKey: 'nav.cash' },
      { key: 'forecast', path: '/app/forecast', icon: LineChart, labelKey: 'nav.forecast' },
      { key: 'plan', path: '/app/plan', icon: Sparkles, labelKey: 'nav.plan' },
    ],
  },
  {
    labelKey: 'nav.group.action',
    items: [
      { key: 'alerts', path: '/app/alerts', icon: AlertTriangle, labelKey: 'nav.alerts' },
      { key: 'recommendations', path: '/app/recommendations', icon: Lightbulb, labelKey: 'nav.recommendations' },
      { key: 'tasks', path: '/app/tasks', icon: CheckSquare, labelKey: 'nav.tasks' },
      { key: 'documents', path: '/app/documents', icon: FolderOpen, labelKey: 'nav.documents' },
      { key: 'calendar', path: '/app/calendar', icon: CalendarDays, labelKey: 'nav.calendar' },
      { key: 'advisor', path: '/app/advisor', icon: MessageSquareText, labelKey: 'nav.advisor' },
      { key: 'team', path: '/app/team', icon: Users, labelKey: 'nav.team' },
    ],
  },
];

export const bottomNavItems = [
  { key: 'today', path: '/app/today', icon: Home, labelKey: 'nav.today' },
  { key: 'finance', path: '/app/finance', icon: Euro, labelKey: 'nav.finance' },
  { key: 'alerts', path: '/app/alerts', icon: AlertTriangle, labelKey: 'nav.alerts' },
];
